module.exports = __webpack_public_path__ + "img/tools-data-quality.bd776d56.png";